/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import Section from 'bundles/front-page/components/Section';
import OverflowCarousel from 'bundles/front-page/components/overflow-carousel/OverflowCarousel';
import CompactCollection from 'bundles/front-page/redesign-modules/compact-collections/CompactCollection';

type PresetCollectionSetType = {
  id: string;
  collectionModuleId: string;
  presetCollectionId: string;
};

type ComplexCollectionSetType = {
  id: string;
  collectionModuleId: string;
  collectionName: string;
  facets: Array<Array<string>>;
};

type CollectionSetType = PresetCollectionSetType | ComplexCollectionSetType;

type Props = {
  headline: string;
  collections: {
    headline: string;
    headlineTarget: string;
    collection: CollectionSetType;
  }[];
};

const styles = {
  collectionsGrid: css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    gap: calc(var(--cds-spacing-150) / 2 * 3);
    width: 100%;

    ${breakpoints.down('sm')} {
      grid-template-columns: repeat(3, minmax(343px, 1fr));
      width: auto;
    }
  `,
};

const CompactCollectionsModuleRenderer = ({ headline, collections }: Props) => {
  return (
    <Section title={headline}>
      <OverflowCarousel css={styles.collectionsGrid}>
        {collections.map((collection) => (
          <CompactCollection key={collection.headline} {...collection} />
        ))}
      </OverflowCarousel>
    </Section>
  );
};

export default CompactCollectionsModuleRenderer;
